import Box from '@mui/material/Box';
import Spinner from '../../../common/components/Spinner';

export function ViewLoader() {
	return (
		<Box sx={{ display: 'flex' }}>
			<Spinner />
		</Box>
	);
}
